import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../admin/admin.service';
import { IExtendedUserList } from '@models/general/user';
import { MatDialog } from '@angular/material/dialog';
import { PasswordResetDialogComponent } from './password-reset-dialog.component';
import { UserFormAdminComponent } from './user-form.component';
import { TopBarService } from 'src/app/top-bar/top-bar.service';

@Component({
  selector: 'mood-user-list-admin',
  templateUrl: './user-list.component.html',
  styleUrls: ['user-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserListAdminComponent implements OnInit, OnDestroy {
  @ViewChild(UserFormAdminComponent) userFormAdminComponent!: UserFormAdminComponent;

  currentUserEditing?: string;

  userList: IExtendedUserList[] = [];

  constructor(
    private _adminService: AdminService,
    private _changeDetector: ChangeDetectorRef,
    private _dialog: MatDialog,
    private _topBarService: TopBarService,
  )
  {
    this._topBarService.setTitle('User List');
  }

  ngOnDestroy(): void {
  }

  async ngOnInit() {
    await this._loadUsers();
  }

  private async _loadUsers() {
    this.userList = await this._adminService.getUsers(true) as IExtendedUserList[];

    this._changeDetector.markForCheck();
  }

  public toggleUserEdit(user: IExtendedUserList) {
    if (this.currentUserEditing === user.id) {
      this.currentUserEditing = '';
    } else {
      this.currentUserEditing = user.id;
    }
  }

  public async resetUserPassword(user: IExtendedUserList) {
    this._dialog.open(PasswordResetDialogComponent, {
      data: user
    });
  }

  addNewUser() {
    this.currentUserEditing = this.currentUserEditing === 'new' ? '' : 'new';
  }

  async onCloseEvent(data: any) {
    this.currentUserEditing = '';
    await this._loadUsers();
  }
}

